module.exports = __webpack_public_path__ + "img/q11.3803650c.png";